<script setup>
import LoadingSpinner from "@/components/Spinner.vue";
import {useStore} from "vuex";
import {computed} from "vue";
const store = useStore()
const loading = computed(()=> store.getters.getLoading)
</script>
<template>
  <div id="wrap">
    <div class="sub">
      <section class="container">
<!--        <Header/>-->
        <LoadingSpinner v-if="loading"></LoadingSpinner>
        <router-view/>
      </section>
    </div>
  </div>
</template>
